export default {
  separator: {
    marginLeft: 0,
    marginRight: 0
  }
};
